import React from "react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Typography from "@mui/material/Typography";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import { Tooltip, Chip } from "@mui/material";
import { backend_url } from "../../App";
// import { Link } from "react-router-dom";

export default function Camera(props) {
  let content = props.content;
  let latest = `${backend_url}/media/${props.content.latest_event}`;
  let liveC = content.live;
  let id = content.id;
  // let location = "Lat:" + content.latitude + " ,Lng:" + content.longitude;

  // Helper function to get relative time
  const getRelativeTime = (dateString) => {
    if (!dateString) return "Never";

    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInMonths = Math.floor(diffInDays / 30);
    const diffInYears = Math.floor(diffInDays / 365);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} second${diffInSeconds !== 1 ? "s" : ""} ago`;
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes !== 1 ? "s" : ""} ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""} ago`;
    } else if (diffInDays < 30) {
      return `${diffInDays} day${diffInDays !== 1 ? "s" : ""} ago`;
    } else if (diffInMonths < 12) {
      return `${diffInMonths} month${diffInMonths !== 1 ? "s" : ""} ago`;
    } else {
      return `${diffInYears} year${diffInYears !== 1 ? "s" : ""} ago`;
    }
  };

  // Helper function to get camera status
  const getCameraStatus = (camera) => {
    const isLive = camera.live === true;
    const lastReportedAt = camera.last_reported_at;

    if (!isLive) {
      return { label: "UNARMED", color: "error", iconColor: "#d32f2f" };
    }

    if (!lastReportedAt) {
      return { label: "OFFLINE", color: "warning", iconColor: "#ed6c02" };
    }

    const lastReported = new Date(lastReportedAt);
    const now = new Date();
    const diffInHours = (now - lastReported) / (1000 * 60 * 60);

    if (diffInHours <= 1) {
      return { label: "ARMED", color: "success", iconColor: "#2e7d32" };
    } else {
      return { label: "OFFLINE", color: "warning", iconColor: "#ed6c02" };
    }
  };

  const getDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const hours = date.getHours();
    date.setHours(hours + 5);
    const updatedDate = date.toISOString().slice(0, 16).replace("T", " ");
    return updatedDate;
  };

  // const scrollToTop = () => {
  //   window.scrollTo(0, 0);
  // };

  const status = getCameraStatus(content);
  const statusColor =
    status.color === "success"
      ? "success"
      : status.color === "warning"
        ? "warning"
        : "error";

  return (
    <div
      className="card rounded my-1 shadow-lg back-card"
      style={{
        width: "100%", // Change from fixed 230px to 100%
        maxWidth: "460px", // Set a max width for larger screens
        minWidth: "250px", // Set a minimum width for smaller screens
        height: "fit-content",
        maxHeight: "460px",
        position: "relative",
        borderLeft:
          status.color === "success"
            ? "4px solid #2e7d32"
            : status.color === "warning"
              ? "4px solid #ed6c02"
              : "4px solid #d32f2f",
      }}
    >
      {liveC ? (
        <Tooltip title="Live View" placement="top">
          <button
            style={{
              border: "none",
              borderRadius: "10px",
              background: "transparent",
            }}
            onClick={() => {
              window.location.href = `/live/${id}`;
            }}
          >
            <img
              src={require("../../images/live.gif")}
              alt="live"
              style={{ width: "15px", height: "15px", marginBottom: "3px" }}
            />
          </button>
        </Tooltip>
      ) : (
        <Tooltip title="Unarmed">
          <p style={{ height: "10px" }}></p>
        </Tooltip>
      )}

      <Typography
        variant="subtitle2"
        gutterBottom
        component="div"
        marginTop={1}
        marginLeft={2}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingRight: "10px",
        }}
      >
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <FiberManualRecordIcon
            sx={{
              color: status.iconColor,
              fontSize: "12px",
              animation:
                status.label === "ARMED" ? "pulse 1.5s infinite" : "none",
              "@keyframes pulse": {
                "0%": { opacity: 1 },
                "50%": { opacity: 0.5 },
                "100%": { opacity: 1 },
              },
            }}
          />
          <span>{content.description}</span>
        </span>
        <Chip
          label={status.label}
          size="small"
          color={statusColor}
          sx={{
            height: "20px",
            fontSize: "0.7rem",
            fontWeight: "bold",
            "& .MuiChip-label": { px: 1, py: 0.5 },
          }}
        />
      </Typography>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "5px",
        }}
      >
        <img
          src={latest}
          alt=""
          className="card-img-top time"
          style={{
            width: "150px",
            height: "150px",
            borderRadius: "15px",
            objectFit: "cover",
          }}
          onError={(e) => {
            e.target.src = "/video.png";
          }}
        />
      </div>

      <Typography
        style={{
          borderTop: "groove",
          borderBottom: "groove",
          display: "flex",
          justifyContent: "center",
          marginTop: "5px",
          padding: "4px 0",
        }}
      >
        <span style={{ fontSize: "11px", fontWeight: 500 }}>
          Last Event: {getDate(content.last_reported_at)}
        </span>
      </Typography>

      <Typography
        style={{
          // borderBottom: "groove",
          display: "flex",
          justifyContent: "center",
          marginTop: "0px",
          padding: "4px 0",
        }}
      >
        <Tooltip
          title={`Last ping: ${getDate(content.last_reported_at)}`}
          arrow
        >
          <span
            style={{
              fontSize: "11px",
              color:
                status.color === "success"
                  ? "#2e7d32"
                  : status.color === "warning"
                    ? "#ed6c02"
                    : "#d32f2f",
              fontWeight: "bold",
            }}
          >
            Last Ping: {getRelativeTime(content.last_reported_at)}
          </span>
        </Tooltip>
      </Typography>

      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          margin: "8px 5px",
          gap: "5px",
        }}
      >
        <Tooltip title={location} placement="top">
          <Button
            size="small"
            component="span"
            style={{
              border: "1px solid",
              borderColor: "#ddd",
              color: "#555",
              opacity: "0.8",
              fontSize: "10px",
              padding: "4px 8px",
              minWidth: "auto",
            }}
            onClick={() => {
              scrollToTop();
              props.updateMapCenter(content.latitude, content.longitude);
            }}
          >
            <LocationOnIcon style={{ width: "0.8em", marginRight: "4px" }} />
            Location
          </Button>
        </Tooltip>
        <Button
          size="small"
          component={Link}
          to={`/statistics/${content.id}`}
          style={{
            border: "1px solid",
            borderColor: "#ddd",
            color: "#555",
            opacity: "0.8",
            fontSize: "10px",
            padding: "4px 8px",
            minWidth: "auto",
          }}
        >
          <LeaderboardIcon style={{ width: "0.8em", marginRight: "4px" }} />
          Statistics
        </Button>
      </div> */}
    </div>
  );
}
